<template>
  <div v-cloak>
    <!-- class="mobile:view" -->
    <div v-if="$mq === 'mobile'">
      <type-m>
        <router-view :key="$route.fullPath" />
      </type-m>
    </div>
    <div v-else>
      <!-- <div class="desktop:view"> -->
      <div
        class="banner--top position--relative z--100"
        v-if="theme.type !== 'type-e' && banners.top.length > 0"
        :class="isDisplayNode"
      >
        <a
          class="banner--imgs h--100px bg block"
          :style=" `background-image:url(/api/banners/files/${banners.top[0].uuid}/${banners.top[0].files[0].fileName});`"
          @mousedown.left="mousedown"
          @mouseup.left="open(banners.top[0], $event)"
        ></a>
        <form-button
          class="
        icon--btn 
        icon--md
        btn--lg 
        position--absolute 
        top--50% 
        -mt--20px 
        right--16px  
        text--white"
          icon="close"
          type="button"
          @click="close"
        ></form-button>
      </div>
      <type-a v-if="theme.type === 'type-a'">
        <router-view :key="$route.fullPath" />
      </type-a>
      <type-b v-else-if="theme.type === 'type-b'">
        <router-view :key="$route.fullPath" />
      </type-b>
      <type-c v-else-if="theme.type === 'type-c'">
        <router-view :key="$route.fullPath" />
      </type-c>
      <type-d v-else-if="theme.type === 'type-d'">
        <router-view :key="$route.fullPath" />
      </type-d>
      <type-e
        v-else-if="theme.type === 'type-e'"
        :class="themeClasses('bgColor')"
      >
        <router-view :key="$route.fullPath" />
      </type-e>
      <type-h v-else-if="theme.type === 'type-h'">
        <router-view :key="$route.fullPath" />
      </type-h>

    </div>
    <div
      class="quickbar"
      v-if="$mq !== 'mobile' && !isAdminMode "
    >
      <ul class="w--100px">
        <li
          v-for="quick in banners.quick"
          :key="quick.seq"
        >
          <a @click="quickClick(quick)">
            <img
              :src="`/api/banners/files/${quick.uuid}/${quick.files[0].fileName}`"
              class="w--100%"
            >
          </a>
        </li>
      </ul>
    </div>
    <!-- 
    <div class="quickbar">
      <ul class="w--60px">
        <li>
          <a href="#">
            <img
              src="/api/resources/files/main-quick-1.png"
              class="w--100%"
            >
          </a>
        </li>
        <li>
          <a href="#">
            <img
              src="/api/resources/files/main-quick-2.png"
              class="w--100%"
            >
          </a>
        </li>
        <li>
          <a href="#">
            <img
              src="/api/resources/files/main-quick-3.png"
              class="w--100%"
            >
          </a>
        </li>
        <li>
          <a href="#">
            <img
              src="/api/resources/files/main-quick-4.png"
              class="w--100%"
            >
          </a>
        </li>
        <li>
          <a href="#">
            <img
              src="/api/resources/files/main-quick-5.png"
              class="w--100%"
            >
          </a>
        </li>
        <li>
          <a href="#">
            <img
              src="/api/resources/files/main-quick-top.png"
              class="w--100%"
            >
          </a>
        </li>
      </ul>
    </div> -->
  </div>

</template>

<script>
import theme from '@/component/js/theme'
import { mapState } from 'vuex'

export default {
  mixins: [theme],
  data () {
    return {
      closed: false,
      position: {
        x: -1,
        y: -1
      }
    }
  },
  created () {
    if (this.banners.top.length > 0) {
      const lastTime = localStorage.getItem(`topBanner-${this.banners.top[0].seq}`)
      const nowTime = new Date().getTime() - (1000 * 60 * 60 * 24)
      // console.log('nowTime', lastTime, nowTime, (lastTime && (lastTime > nowTime)) || false)

      this.closed = lastTime && (lastTime > nowTime)
    }
  },
  computed: {
    ...mapState(['company', 'banners']),
    isDisplayNode () {
      return this.closed ? 'display-none' : ''
    },
    isAdminMode () {
      return this.$route.name.startsWith('admin')
    }
  },
  methods: {
    close () {
      this.closed = true
      localStorage.setItem(`topBanner-${this.banners.top[0].seq}`, new Date().getTime())
    },
    mousedown ($event) {
      this.position.x = $event.x
      this.position.y = $event.y
    },
    open (banner, $event) {
      if (this.position.x === $event.x && this.position.y === $event.y) {
        if (banner.newWindowFlag === 'Y') {
          window.open(banner.link, '_blank')
        } else {
          location.href = banner.link
        }
      }
      this.position.x = -1
      this.position.y = -1
    },
    quickClick (quick) {
      if (quick.link === 'top') {
        window.scrollTo(0, 0)
      } else if (quick.newWindowFlag === 'Y') {
        window.open(quick.link, '_blank')
      } else {
        location.href = quick.link
      }
    }
  },
  components: {
    TypeA: () => import('@/component/container/TypeA'),
    TypeB: () => import('@/component/container/TypeB'),
    TypeC: () => import('@/component/container/TypeC'),
    TypeD: () => import('@/component/container/TypeD'),
    TypeE: () => import('@/component/container/TypeE'),
    TypeH: () => import('@/component/container/TypeH'),
    TypeM: () => import('@/component/container/TypeM'),
    FormButton: () => import('@/component/ui2/button/FormButton')
  }
}
</script>
